module.exports = __webpack_public_path__ + "img/bem-vindo-vacina-sesi.e04e83ee.png";